export const fetchWithTimeout = async (fetchFunction, timeout = 700000) => {
  const fetchWithTimeoutPromise = new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error("Request timed ouoooooot"));
    }, timeout);

    fetchFunction()
      .then((data) => {
        clearTimeout(timer);
        resolve(data);
      })
      .catch((error) => {
        clearTimeout(timer);
        reject(error);
      });
  });

  try {
    const [result, error] = await fetchWithTimeoutPromise;

    return [result, error];
  } catch (error) {
    return [null, error];
  }
};
